$(document).on('turbolinks:load', function() {

	var $e90Inputs = $('input.e90-input');

	$e90Inputs.each(function() {

		var $input = $(this);
		var $parentDiv = $input.parent();
		var $label = $parentDiv.find('label');

		// console.log('$input:', $input);
		// console.log('$parentDiv:', $parentDiv);
		// console.log('$label:', $label);

		var inputId = $input.attr('id');
		// console.log('inputId:', inputId);
		var newInputId = inputId + '_e90';

		// var labelFor = $label.attr('for');
		// console.log('labelFor:', labelFor);

		$input.attr('id', newInputId);
		$label.attr('for', newInputId);

		// console.log('input AFTER change:', $input.attr('id'));
		// console.log('label AFTER change:', $label.attr('for'));
	});
});
